import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { forkJoin, map, Observable } from 'rxjs';
import { PropertyDefinition } from 'src/app/models/gum-models/property-definition';
import { ServiceBase } from '../service-base';
import { GumOrganizationsService } from './gum-organizations.service';

@Injectable({
    providedIn: 'root',
})
export class PropertyDefinitonsService extends ServiceBase {
    constructor(
        private http: HttpClient,
        private organizationsServices: GumOrganizationsService
    ) {
        super();
    }

    getPropertyDefinitions(): Observable<PropertyDefinition[]> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization()?.id ?? ''),
        };

        return forkJoin([this.http.get<PropertyDefinition[]>(`${this.apiUrl}/api/gum/definitions/properties`, httpOptions), this.organizationsServices.getOrganisations()]).pipe(
            map((result) => {
                const definitions = result[0];
                const organizations = result[1];

                definitions.forEach((definition) => {
                    const organization = organizations.find((x) => x.id === definition.organizationId);
                    definition.displayOrganization = organization ? organization.display : '';
                    definition.legacy =
                        this.organizationsServices.getCurrentOrganization() && definition.organizationId === this.organizationsServices.getCurrentOrganization()?.id ? false : true;
                });

                return definitions;
            })
        );
    }

    getPropertyDefinition(propertyDefinitionName: string): Observable<PropertyDefinition> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization()?.id ?? ''),
        };

        return this.http.get<PropertyDefinition>(`${this.apiUrl}/api/gum/definitions/properties/${encodeURIComponent(propertyDefinitionName)}`, httpOptions);
    }

    getPropertyDefinitionWithLegacy(propertyDefinitionName: string): Observable<PropertyDefinition> {
        return this.getPropertyDefinition(propertyDefinitionName).pipe(
            map((propertyDefinition) => {
                propertyDefinition.legacy =
                    this.organizationsServices.getCurrentOrganization() && propertyDefinition.organizationId === this.organizationsServices.getCurrentOrganization()?.id
                        ? false
                        : true;

                return propertyDefinition;
            })
        );
    }

    addPropertyDefinition(propertyDefinition: PropertyDefinition): Observable<PropertyDefinition> {
        const httpOptions = {
            headers: new HttpHeaders().set('Content-Type', 'application/json').set('X-OrganizationId', this.organizationsServices.getCurrentOrganization()?.id ?? ''),
        };

        return this.http.post<PropertyDefinition>(`${this.apiUrl}/api/gum/definitions/properties`, propertyDefinition, httpOptions);
    }

    deletePropertyDefinition(propertyDefinitionName: string) {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization()?.id ?? ''),
        };

        return this.http.delete(`${this.apiUrl}/api/gum/definitions/properties/${encodeURIComponent(propertyDefinitionName)}`, httpOptions);
    }

    updatePropertyDefinition(propertyDefinition: PropertyDefinition, globalNotification = true): Observable<PropertyDefinition> {
        const httpOptions = {
            headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
                .set('global-notification', String(globalNotification))
                .set('X-OrganizationId', this.organizationsServices.getCurrentOrganization()?.id ?? ''),
        };

        return this.http.patch<PropertyDefinition>(`${this.apiUrl}/api/gum/definitions/properties/${encodeURIComponent(propertyDefinition.name)}`, propertyDefinition, httpOptions);
    }
}
